var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm._headers,"items":_vm.mandates,"dense":"","disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:`item.actions`,fn:function({ item }){return [_c('mandate-modal',{attrs:{"mandateInput":item}}),_c('delete-mandate-modal',{attrs:{"mandate":item}})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }